module.exports = __webpack_public_path__ + "img/video-shuffler-002.f96006a4.png";